import apiClient from '@/services/axios'

export async function put(setupId, section) {

  var response = await apiClient.post(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setups/' + setupId + '/venue-sections', section);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to post section.')
}
